/**
 * Calculation type values
 */
export enum CalculationTypeEnum {
	ADDITIVE = 'additive',
	MULTIPLICATIVE = 'multiplicative',
	PERCENTAGE = 'percentage',
}
